import React from 'react';
import { ArrowRight } from 'lucide-react';
import { IITH, SERIF, SANS } from './iithBrand';

export default function LandingHero({
  name, logo, primary, tagline, heroStyle, onBook, onSpecialties,
}) {
  const accent = primary || IITH.saffron;
  const brand = name || IITH.hospital;

  return (
    <section className="relative overflow-hidden min-h-[78vh] flex items-center" style={heroStyle}>
      {/* Institutional geometry */}
      <div className="absolute inset-0 pointer-events-none opacity-[0.07]"
        style={{
          backgroundImage:
            'linear-gradient(to right, white 1px, transparent 1px), linear-gradient(to bottom, white 1px, transparent 1px)',
          backgroundSize: '72px 72px',
        }}
      />
      <div
        className="absolute top-0 left-0 right-0 h-1"
        style={{ background: `linear-gradient(90deg, ${accent}, ${IITH.gold}, ${accent})` }}
      />
      <div
        className="absolute -right-24 top-1/4 h-[420px] w-[420px] rounded-full blur-3xl opacity-30 pointer-events-none"
        style={{ background: accent }}
      />

      <div className="max-w-6xl mx-auto px-5 sm:px-6 py-16 sm:py-24 relative w-full">
        <div className="max-w-3xl">
          {logo && (
            <img
              src={logo}
              alt={brand}
              className="h-20 w-20 sm:h-24 sm:w-24 object-contain bg-white rounded-full p-2 shadow-2xl shadow-black/40 mb-7 animate-[fadeUp_0.7s_ease-out]"
            />
          )}
          <p
            className="text-[11px] sm:text-xs uppercase tracking-[0.28em] font-medium mb-4"
            style={{ color: IITH.gold, fontFamily: SANS }}
          >
            {IITH.institute}
          </p>
          <h1
            className="text-4xl sm:text-5xl lg:text-[3.65rem] font-bold leading-[1.08] tracking-tight text-white mb-3"
            style={{ fontFamily: SERIF }}
            data-testid="hero-brand"
          >
            {brand}
          </h1>
          <p className="text-lg sm:text-xl text-[#E8EEF5]/90 font-medium mb-5" style={{ fontFamily: SERIF }}>
            {IITH.headline}
          </p>
          <p className="text-[15px] sm:text-base text-[#9AADBE] max-w-xl leading-relaxed mb-8">
            {tagline ? `${tagline}. ${IITH.support}` : IITH.support}
          </p>
          <div className="flex flex-wrap gap-3">
            <button
              type="button"
              onClick={onBook}
              className="inline-flex items-center gap-2 px-7 py-3.5 text-sm font-semibold text-white shadow-xl shadow-black/30 transition hover:brightness-110"
              style={{ background: accent, fontFamily: SANS }}
              data-testid="hero-book"
            >
              Book an OPD appointment <ArrowRight className="h-4 w-4" />
            </button>
            <button
              type="button"
              onClick={onSpecialties}
              className="inline-flex items-center gap-2 px-7 py-3.5 text-sm font-medium text-white border border-white/25 hover:bg-white/5 transition"
              style={{ fontFamily: SANS }}
              data-testid="hero-specialties"
            >
              View specialties
            </button>
          </div>
        </div>
      </div>
      <style>{`
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(12px); }
          to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </section>
  );
}
